// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single .select2-selection__clear{margin-right:20px}.single .select2-selection__rendered:after{content:none!important}
`, "",{"version":3,"sources":["webpack://./admin-components/tag-editor.vue"],"names":[],"mappings":"AAAA,kCACE,iBAAA,CAEF,2CACE,sBAAA","sourcesContent":[".single .select2-selection__clear {\n  margin-right: 20px;\n}\n.single .select2-selection__rendered:after {\n  content: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
